import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FlexView from 'react-flexview/lib';

import * as actions from '../store/actions/churgerBuilderActions';

import Drugs from '../components/OurMenu/Drugs';
import Weapons from '../components/OurMenu/Weapons';
import Modal from '../shared/Modal';

export default function Menu() {
	const [clickedImg, setClickedImg] = useState(null);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(actions.setPage('notOrder'));
	});

	return (
		<FlexView
			column
			className="menu"
			hAlignContent="center"
			vAlignContent="center"
		>
			<Drugs setClickedImg={setClickedImg} />
			<Weapons setClickedImg={setClickedImg} />
			{clickedImg && (
				<Modal clickedImg={clickedImg} setClickedImg={setClickedImg} />
			)}
		</FlexView>
	);
}
